export const keyboardEvents = {
  upArrow: 38,
  downArrow: 40,
  escape: 27,
  enter: 13,
  tab: 9,
};
